export default __webpack_public_path__ + "static/slg-jalkeen-8a3627c489dd43647c3eceb240bb3762.jpg";